module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-modal modal fade noselect",
    attrs: {
      "id": "modalValidation"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.titleModal) + " d'un valideur")]), _vm._v(" "), (_vm.dataReady) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "title": "Fermer"
    }
  }, [_c('span', {
    staticClass: "fas fa-times"
  })]) : _vm._e()]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [(!_vm.dataReady) ? _c('div', {
    staticClass: "tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-bottom-0 tw-bg-gray-500/10 tw-z-10"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-items-center"
  }, [_c('input-select', {
    staticClass: "tw-mr-3 tw-grow",
    attrs: {
      "code": "key",
      "display": "value",
      "label": "Liste des personnes",
      "disabled": !_vm.dataReady,
      "first": false,
      "list": _vm.transformList(_vm.listeUtilisateurs),
      "vmodel": _vm.currentIdUtilisateur
    },
    on: {
      "update:vmodel": function($event) {
        _vm.currentIdUtilisateur = $event
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "tw-mr-3",
    attrs: {
      "code": "key",
      "display": "value",
      "label": "Niveau de validation",
      "disabled": !_vm.dataReady,
      "first": false,
      "list": _vm.listValidation,
      "vmodel": _vm.currentIdNiveau
    },
    on: {
      "update:vmodel": function($event) {
        _vm.currentIdNiveau = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inp-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valideurConges.EnvoiEmail),
      expression: "valideurConges.EnvoiEmail"
    }],
    attrs: {
      "type": "checkbox",
      "id": "notificationMail",
      "disabled": !_vm.dataReady
    },
    domProps: {
      "checked": Array.isArray(_vm.valideurConges.EnvoiEmail) ? _vm._i(_vm.valideurConges.EnvoiEmail, null) > -1 : (_vm.valideurConges.EnvoiEmail)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.valideurConges.EnvoiEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.valideurConges, "EnvoiEmail", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.valideurConges, "EnvoiEmail", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.valideurConges, "EnvoiEmail", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer tw-mt-5 tw-pr-0"
  }, [_c('div', {
    staticClass: "area-action"
  }, [_c('button', {
    staticClass: "inp-button-modal valid",
    class: {
      'tw-bg-amber-500': !_vm.isNew
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.dataReady
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.isNew ? "Valider" : "Modifier"))])]), _vm._v(" "), _c('button', {
    staticClass: "inp-button-modal cancel ml-1",
    attrs: {
      "type": "button",
      "disabled": !_vm.dataReady
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Annuler")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-flex tw-mb-3 tw-bg-blue-50 tw-rounded"
  }, [_c('div', {
    staticClass: "tw-p-2 tw-mr-1 tw-flex tw-items-center"
  }, [_c('span', {
    staticClass: "fa-solid fa-circle-info fa-xl tw-text-blue-500"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tw-py-2 tw-pr-2"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLes niveaux correspondent aux étapes successives de validation (1 puis 2). Il est également possible d'activer ou de désactiver l'envoi des mails de notifications aux valideurs d'absences.\n\t\t\t\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "notificationMail"
    }
  }, [_c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Notifier par email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45096aed"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ficheSalarie/absences/validationAbsence/modalValidation/modalValidation.vue.html
// module id = kBtq
// module chunks = 2